module.exports = __webpack_public_path__ + "img/tour-home-page.502653c2.svg";